
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.017 3.216a9 9 0 015.646.557 1 1 0 10.814-1.826A11 11 0 1023 12v-.92a1 1 0 10-2 0V12a9 9 0 11-10.983-8.784zm12.69 1.49a1 1 0 00-1.415-1.413L12 12.595l-2.293-2.292a1 1 0 10-1.414 1.414l3 3a1 1 0 001.415 0l10-10.01z","fill":"#04080E"}})])
          )
        }
      }
    